import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { GovtServersAddPageComponent } from './govt-servers-add-page.component';

const routes: Routes = [
  {
    path: 'govt-servers-add',
    component: GovtServersAddPageComponent,
  },
  {
    path: 'govt-servers-add/:id',
    component: GovtServersAddPageComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class GovtServersAddPageRoutingModule {}
